import { ncbDataClient } from './ncbClient';

const GUEST_DB_KEY = 'mock_countdowns_cute_db_v11';

const generateDemoData = () => {
  const today = new Date();
  const addDays = (days) => new Date(today.getTime() + days * 86400000).toISOString().split('T')[0];
  return [
    { id: 'demo1', title: 'demo.concert.title', icon: '🎵', theme: 'sakura', category: 'life', targetDateISO: addDays(15), isPinned: false, note: 'demo.concert.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo2', title: 'demo.trip.title', icon: '✈️', theme: 'sky', category: 'travel', targetDateISO: addDays(45), isPinned: false, note: 'demo.trip.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo3', title: 'demo.birthday.title', icon: '🎂', theme: 'butter', category: 'birthday', targetDateISO: addDays(10), isPinned: false, note: 'demo.birthday.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo4', title: 'demo.project.title', icon: '💻', theme: 'mint', category: 'work', targetDateISO: addDays(3), isPinned: true, note: 'demo.project.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo11', title: 'demo.anniversary.title', icon: '❤️', theme: 'lavender', category: 'love', targetDateISO: addDays(20), isPinned: false, note: 'demo.anniversary.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo12', title: 'demo.braces.title', icon: '🦷', theme: 'sky', category: 'other', targetDateISO: addDays(60), isPinned: false, note: 'demo.braces.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo5', title: 'demo.firstDate.title', icon: '☕', theme: 'lavender', category: 'love', targetDateISO: addDays(-100), isPinned: true, note: 'demo.firstDate.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo6', title: 'demo.graduation.title', icon: '🎓', theme: 'elapsed', category: 'other', targetDateISO: addDays(-365), isPinned: false, note: 'demo.graduation.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo7', title: 'demo.firstTrip.title', icon: '🌎', theme: 'sky', category: 'travel', targetDateISO: addDays(-500), isPinned: false, note: 'demo.firstTrip.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo8', title: 'demo.newHouse.title', icon: '🏠', theme: 'mint', category: 'life', targetDateISO: addDays(-200), isPinned: false, note: 'demo.newHouse.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo9', title: 'demo.firstJob.title', icon: '💼', theme: 'butter', category: 'work', targetDateISO: addDays(-800), isPinned: false, note: 'demo.firstJob.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo10', title: 'demo.eighteen.title', icon: '👑', theme: 'sakura', category: 'birthday', targetDateISO: addDays(-1000), isPinned: false, note: 'demo.eighteen.note', isDemo: true, createdAtISO: today.toISOString() },
    { id: 'demo13', title: 'demo.cat.title', icon: '🐱', theme: 'butter', category: 'other', targetDateISO: addDays(-50), isPinned: false, note: 'demo.cat.note', isDemo: true, createdAtISO: today.toISOString() }
  ];
};

const getLocalDb = () => {
  const data = localStorage.getItem(GUEST_DB_KEY);
  if (data) {
    const parsed = JSON.parse(data);
    const today = new Date();
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let isModified = false;
    const updatedData = parsed.map(item => {
      if (item.isDemo && item.createdAtISO) {
        const created = new Date(item.createdAtISO);
        const createdMidnight = new Date(created.getFullYear(), created.getMonth(), created.getDate());
        const diffDays = Math.round((todayMidnight - createdMidnight) / 86400000);
        if (diffDays > 0) {
          const [y, m, d] = item.targetDateISO.split('T')[0].split('-').map(Number);
          const target = new Date(y, m - 1, d);
          target.setDate(target.getDate() + diffDays);
          item.targetDateISO = `${target.getFullYear()}-${String(target.getMonth() + 1).padStart(2, '0')}-${String(target.getDate()).padStart(2, '0')}`;
          item.createdAtISO = today.toISOString();
          isModified = true;
        }
      }
      return item;
    });
    if (isModified) saveLocalDb(updatedData);
    return updatedData;
  }
  const demoData = generateDemoData();
  saveLocalDb(demoData);
  return demoData;
};

const saveLocalDb = (data) => {
  localStorage.setItem(GUEST_DB_KEY, JSON.stringify(data));
};

const normalizeItem = (item) => {
  if (!item) return item;
  return {
    ...item,
    id: item.id,
    targetDateISO: item.targetdateiso || item.target_date || item.targetDateISO || item.TargetDate || new Date().toISOString().split('T')[0],
    isPinned: Boolean(item.ispinned ?? item.is_pinned ?? item.isPinned ?? item.IsPinned ?? false),
    createdAtISO: item.created_at || item.createdAtISO || new Date().toISOString(),
    updatedAtISO: item.updated_at || item.updatedAtISO || new Date().toISOString(),
  };
};

const formatForDb = (data, userId) => {
  const payload = {
    title: data.title,
    icon: data.icon,
    theme: data.theme,
    category: data.category,
    note: data.note,
    targetdateiso: data.targetDateISO,
    ispinned: data.isPinned ? 1 : 0,
    user_id: userId,
  };
  Object.keys(payload).forEach(key => {
    if (payload[key] === undefined || payload[key] === null) delete payload[key];
  });
  return payload;
};

const getScopedEndpoint = (action, userId, id = null) => {
  const path = id === null ? `/${action}/countdowns` : `/${action}/countdowns/${encodeURIComponent(id)}`;
  const params = new URLSearchParams({
    owner_id: String(userId),
    user_id: String(userId),
  });

  if (action === 'read') {
    params.set('limit', '500');
  }

  return `${path}?${params.toString()}`;
};

const validateEvent = (data) => {
  if (!data?.title?.trim()) throw new Error('errors.missingTitle');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(data?.targetDateISO || '')) {
    throw new Error('errors.invalidDate');
  }
};

export const countdownRepository = {
  async list(userId = 'guest') {
    if (userId === 'guest') {
      return getLocalDb().map(normalizeItem);
    }

    // 🚨 countdowns 有 shared_readwrite 政策 → 必須用 ncbDataClient（/data/ 路由）
    const res = await ncbDataClient(getScopedEndpoint('read', userId), { method: 'GET' });

    if (res?.status === 'error') {
      throw new Error(res.error || 'Failed to fetch');
    }

    // 標準信封：res.data 是陣列
    const items = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
    return items
      .map(normalizeItem)
      .filter(item => item?.id !== undefined && String(item?.user_id || '') === String(userId));
  },

  async create(userId = 'guest', data) {
    validateEvent(data);
    const newItem = {
      title: data.title.trim(),
      icon: data.icon || '✨',
      theme: data.theme || 'sakura',
      category: data.category || 'other',
      targetDateISO: data.targetDateISO,
      isPinned: data.isPinned || false,
      note: (data.note || '').trim(),
    };

    if (userId === 'guest') {
      const db = getLocalDb();
      if (newItem.isPinned) {
        db.forEach(item => {
          if (item.category === newItem.category) item.isPinned = false;
        });
      }
      const guestItem = {
        ...newItem,
        id: crypto.randomUUID(),
        userId: 'guest',
        createdAtISO: new Date().toISOString()
      };
      db.push(guestItem);
      saveLocalDb(db);
      return guestItem;
    }

    const dbPayload = formatForDb(newItem, userId);
    const res = await ncbDataClient(getScopedEndpoint('create', userId), {
      method: 'POST',
      body: JSON.stringify(dbPayload),
    });

    if (res?.status === 'error') {
      throw new Error(res.error || 'Failed to create');
    }

    const responseData = res?.data?.data || res?.data || res;
    const createdId = responseData?.id;
    if (createdId === undefined || createdId === null) {
      throw new Error('Failed to create: missing record ID');
    }

    return normalizeItem({ ...dbPayload, id: createdId });
  },

  async update(userId = 'guest', id, data) {
    validateEvent(data);
    if (userId === 'guest') {
      const updateData = { ...data };
      delete updateData.id;
      delete updateData.userId;
      const db = getLocalDb();
      const index = db.findIndex(item => item.id === id);
      if (index === -1) throw new Error('errors.notFound');
      if (updateData.isPinned) {
        const targetCategory = updateData.category || db[index].category;
        db.forEach(item => {
          if (item.id !== id && item.category === targetCategory) item.isPinned = false;
        });
      }
      updateData.isDemo = false;
      db[index] = { ...db[index], ...updateData, updatedAtISO: new Date().toISOString() };
      saveLocalDb(db);
      return db[index];
    }

    const dbPayload = formatForDb(data, userId);
    const res = await ncbDataClient(getScopedEndpoint('update', userId, id), {
      method: 'PUT',
      body: JSON.stringify(dbPayload),
    });

    if (res?.status === 'error') {
      throw new Error(res.error || 'Failed to update');
    }

    return normalizeItem({ ...dbPayload, id });
  },

  async remove(userId = 'guest', id) {
    if (userId === 'guest') {
      const db = getLocalDb();
      saveLocalDb(db.filter(item => item.id !== id));
      return;
    }

    const res = await ncbDataClient(getScopedEndpoint('delete', userId, id), { method: 'DELETE' });

    if (res?.status === 'error') {
      throw new Error(res.error || 'Failed to delete');
    }
  },

  async migrateGuestData(userId = localStorage.getItem('user_id')) {
    if (!userId) throw new Error('errors.missingCredentials');
    const guestItems = getLocalDb();
    if (guestItems.length === 0) return;
    const itemsToMigrate = guestItems.filter(item => !item.isDemo);
    let migrationSuccess = true;
    for (const item of itemsToMigrate) {
      try {
        await this.create(userId, item);
      } catch (e) {
        console.warn(`Failed to migrate item: ${item.title}`);
        migrationSuccess = false;
      }
    }
    if (migrationSuccess) {
      localStorage.removeItem(GUEST_DB_KEY);
    }
  }
};